import script from "./DateBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DateBlock.vue?vue&type=script&setup=true&lang=js"

import "./DateBlock.vue?vue&type=style&index=0&id=c9d5b2f6&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9d5b2f6"]])

export default __exports__